
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBYxk7GO_3bTiVxLAV1enz9Bgxb-Wp09dk",
  authDomain: "varsa-blog.firebaseapp.com",
  projectId: "varsa-blog",
  storageBucket: "varsa-blog.firebasestorage.app",
  messagingSenderId: "1092711990343",
  appId: "1:1092711990343:web:a6c4af896d9c77c1dd5d62"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);